import {texts} from "@/mixins/config"
export const globals = {
  // mixins: [config],
  computed: {
    headerTitle: function() {
      return this.$store.state.headTitle;
    },
    totalUserPointsEarned: function() {
      return this.$store.state.totalUserPoints;
    },
    countDown: function() {
      return this.$store.state.countDownTimer;
    },
    showBackButton: function() {
      return this.$route.path != "/" && this.$route.path != "/main_page";
    },
    showHistory: function() {
      // return this.$route.fullPath.indexOf('/history') < 0;
      return this.$store.state.showHistory;
    },
    showWallet: function() {
      // return this.$route.fullPath.indexOf('/history') < 0;
      return this.$store.state.showWallet;
    },
    userName: function() {
      return this.$store.state.user.name;
    },
    userPhone: function() {
      return this.$store.state.user.phone;
    },
    partnerID: function() {
      return this.$store.state.partner;
    },
    gameID: function() {
      return this.$store.state.game;
    },
    langCode: function () {
      return this.$store.state.lang;
    },
    isValidRequest: function() {
      var self = this;
      var user_name = self.userName;
      var contact_number = self.userPhone;
      var partner = self.partnerID;
      if(contact_number && partner) {
        return true;
      } else {
        return false;
      }
    },
    alertInfo: function() {
      return this.$store.state.isInfo;
    },
    showAlert: function() {
      return this.$store.state.alert;
    },
    alertMessage: function() {
      return this.$store.state.alertText;
    },
    isHeader: function() {
      return this.$store.state.showHeader;
    },
    shareMessage: function() {
      return this.$store.state.shareText;
    },
    walletType: function() {
      return this.$store.state.wallet.type;
    },
    enableWalletClick: function() {
      return false;//this.$store.state.wallet.type == "cash";
    },
    hasJoined: function() {
      return this.$store.state.user.joined;
    },
    currentRank: function() {
      return this.$store.state.user.rank;
    },
    chancesLeft: function() {
      return this.$store.state.user.chancesLeft;
    },
    isTRPending: function() {
      return this.$store.state.requestedTR;
    },
    isRedeemable: function() {
      return this.$store.state.redeem;
    },
    isSuccess: function() {
      return this.$store.state.success;
    },
    totalEarnedCash: function() {
      return this.$store.state.user.cash;
    },
    isProcessing: function() {
      return this.$store.state.processing;
    },
    allTournamentsList: function() {
      return this.$store.state.allTournamentsList;
    },
    bgTheme: function() {
      return this.$store.state.bg_theme;
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    redirectTo(path, params) {
      this.$router.push({path: '/'+path, query: params });
    },
    getTranslatedText(text){
      try{
        // console.log(texts[text.toLowerCase()][this.langCode]);
        var newText = texts[text.toLowerCase()][this.langCode]
        if (newText == null || newText.length == 0) {
          newText = text
        }
        return newText;
      } catch(e) {
        // console.log(e+"~~~~~~~"+text);
        return text;
      }
    },
    clearTimer() {
      clearInterval(this.$store.state.timer);
    },
    clearTimerArray() {
      arr = this.$store.state.timersArray;
      for (var i = 0; i < arr.length; i++) {
        // console.log("~~~~~~~~~~~"+arr[i]);
        clearTimeout(arr[i]);
      }
    },
    closeAlert() {
      this.alertPopup(false, "");
    },
    getFormattedDateTime(start, end) {
      var start_date_time = new Date(start);
      var end_date_time = new Date(end);

      var start = {};
      var end = {};
      var date_time = {};
      var months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

      var formatted_start_hours;
      var formatted_start_mins;
      var formatted_end_hours;
      var formatted_end_mins;

      if(start_date_time.getHours() <= 9) {
        formatted_start_hours = "0"+start_date_time.getHours()
      } else {
        formatted_start_hours = start_date_time.getHours()
      }

      if(start_date_time.getMinutes() <= 9) {
        formatted_start_mins = "0"+start_date_time.getMinutes()
      } else {
        formatted_start_mins = start_date_time.getMinutes()
      }

      if(end_date_time.getHours() <= 9) {
        formatted_end_hours = "0"+end_date_time.getHours()
      } else {
        formatted_end_hours = end_date_time.getHours()
      }

      if(end_date_time.getMinutes() <= 9) {
        formatted_end_mins = "0"+end_date_time.getMinutes()
      } else {
        formatted_end_mins = end_date_time.getMinutes()
      }

      start.time = formatted_start_hours + ":" + formatted_start_mins;
      var start_date = start_date_time.getDate() <= 9 ? "0"+start_date_time.getDate() : start_date_time.getDate();
      start.date = start_date + " " +  months[start_date_time.getMonth()];
      date_time.start = start;

      end.time = formatted_end_hours + ":" + formatted_end_mins;
      var end_date = end_date_time.getDate() <= 9 ? "0"+end_date_time.getDate() : end_date_time.getDate();
      end.date = end_date + " " + months[end_date_time.getMonth()];
      date_time.end = end;
      return date_time;
    },
    getTimer(is_live, timing) {
      var dateEntered = new Date(timing);
      var now = new Date();
      var difference = dateEntered.getTime() - now.getTime();

      if (difference <= 0) {
        if(!this.$store.state.refreshTournament) {
          this.$store.state.refreshTournament = true;
          this.clearTimer();
        }
        if(is_live && this.$route.path != "/main_page") {
          this.alertPopup(true, "Tournament ended!");
          this.tournamentEnded();
        }
      } else {
        var seconds = Math.floor(difference / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        hours = hours %= 24;
        minutes = minutes %= 60;
        seconds = seconds %= 60;

        var formatted_days;
        if(days > 0) {
          formatted_days = ((days <= 9)  ? ("0" + days + "d:") : (days + "d:"));
        } else {
          formatted_days = "";
        }

        var formatted_hours = ((days > 0 || days == 0) && hours > 0) ? (hours <= 9 ? ("0" + hours + "h:") : hours + "h:") : "";
        var formatted_mins = (minutes <= 9 ? ("0" + minutes + "m:") : minutes + "m:");
        var formatted_secs = (seconds <= 9 ? ("0" + seconds + "s") : seconds + "s");
        var count_down = formatted_days + formatted_hours + formatted_mins + formatted_secs;
        this.$store.state.countDownTimer = count_down;
        this.$store.state.refreshTournament = false;
      }
    },
    getTimerForTimerArray() {
      var self = this;
      if (self.$route.path == "/main_page") {
        setTimeout(function () {
          var all_tournaments = self.allTournamentsList;
          for (var i = 0; i < all_tournaments.length; i++) {
            var tr = all_tournaments[i]
            var is_live = tr.is_live;
            var timing = '';
            if (is_live) {
              timing = tr.ends_at;
            } else {
              timing = tr.starts_at;
            }
            var dateEntered = new Date(timing);
            var now = new Date();
            var difference = dateEntered.getTime() - now.getTime();

            if (difference <= 0) {
              if(is_live && self.$route.path != "/main_page") {
                self.alertPopup(true, "Tournament ended!");
              }
            } else {
              var seconds = Math.floor(difference / 1000);
              var minutes = Math.floor(seconds / 60);
              var hours = Math.floor(minutes / 60);
              var days = Math.floor(hours / 24);

              hours = hours %= 24;
              minutes = minutes %= 60;
              seconds = seconds %= 60;

              var formatted_days;
              if(days > 0) {
                formatted_days = ((days <= 9)  ? ("0" + days + "d:") : (days + "d:"));
              } else {
                formatted_days = "";
              }

              var formatted_hours = ((days > 0 || days == 0) && hours > 0) ? (hours <= 9 ? ("0" + hours + "h:") : hours + "h:") : "";
              var formatted_mins = (minutes <= 9 ? ("0" + minutes + "m:") : minutes + "m:");
              var formatted_secs = (seconds <= 9 ? ("0" + seconds + "s") : seconds + "s");
              var count_down = formatted_days + formatted_hours + formatted_mins + formatted_secs;

              var tr_id = tr.id;
              var tr_data = {}
              tr_data[tr_id] = {tag: (is_live ? "Live" : "Starts"), time: count_down}
              // console.log(tr_data)
              var timerSpan = document.getElementById("tr_timer_"+tr.id);
              if (timerSpan) {
                timerSpan.innerHTML = count_down;
              }
              self.$store.state.tournamentStatus = self.jsonConcat(self.$store.state.tournamentStatus, tr_data)
            }
          }
          self.getTimerForTimerArray();
        }, 1000);
      }
    },
    jsonConcat(o1, o2) {
     for (var key in o2) {
      o1[key] = o2[key];
     }
     return o1;
    },
    alertPopup(status, message) {
      this.$store.state.alert = status;
      this.$store.state.alertText = message;
    },
    updateStoreUserData() {
      var user = JSON.parse(this.$ls.get("userData"));
      this.$store.state.user.phone = user.phone;
      this.$store.state.user.name = user.name;
      this.$store.state.user.rank = user.rank;
      this.$store.state.user.joined = user.joined;
      this.$store.state.user.rank = user.rank;
      this.$store.state.partner = user.partnerID;
      this.$store.state.lang = user.langCode;
      this.$store.state.game = user.gameID;
      this.$store.state.bg_theme = user.bg_theme;
    },
    tournamentEnded() {
      if(this.$ls.get("userData") != null) {
        var user_data = JSON.parse(this.$ls.get("userData"));
        user_data.tournamentID = "";
        this.$ls.set('userData', JSON.stringify(user_data));
      }
    },
    messageToShare(prize, type, name) {
      if(prize > 0) {
        prize = prize + " "
      } else {
        prize = ""
      }
      this.$store.state.shareText = "I'm winning" + " " + prize + type + " " +"on DealShare App by playing " + name;
    },
    timeAgo(date) {
      var seconds = Math.floor((new Date() - new Date(date)) / 1000);
      if(Math.round(seconds/(60*60*24*365.25)) >= 2) return Math.round(seconds/(60*60*24*365.25)) + " years ago";
      else if(Math.round(seconds/(60*60*24*365.25)) >= 1) return "1 year ago";
      else if(Math.round(seconds/(60*60*24*30.4)) >= 2) return Math.round(seconds/(60*60*24*30.4)) + " months ago";
      else if(Math.round(seconds/(60*60*24*30.4)) >= 1) return "1 month ago";
      else if(Math.round(seconds/(60*60*24*7)) >= 2) return Math.round(seconds/(60*60*24*7)) + " weeks ago";
      else if(Math.round(seconds/(60*60*24*7)) >= 1) return "1 week ago";
      else if(Math.round(seconds/(60*60*24)) >= 2) return Math.round(seconds/(60*60*24)) + " days ago";
      else if(Math.round(seconds/(60*60*24)) >= 1) return "1 day ago";
      else if(Math.round(seconds/(60*60)) >= 2) return Math.round(seconds/(60*60)) + " hours ago";
      else if(Math.round(seconds/(60*60)) >= 1) return "1 hour ago";
      else if(Math.round(seconds/60) >= 2) return Math.round(seconds/60) + " minutes ago";
      else if(Math.round(seconds/60) >= 1) return "1 minute ago";
      else if(seconds >= 2) return seconds + " seconds ago";
      else if(seconds == 1) return "1 second ago";
      else return seconds + "just now";
    },
    validateInput(type, value, msg) {
      var reg;
      if(type == 'phone') {
        reg = /^\d{10}$/
      } else if(type == 'otp') {
        reg = /^\d{4}$/
      } else if(type == 'account') {
        reg = /^\d{9,}/
      }

      msg = "Please enter a valid " + msg;
      var is_valid = reg.test(value);
      if(!is_valid) {
        var self = this;
        self.alertPopup(true, msg);
        setTimeout(function() {
          self.closeAlert();
        }, 2000);
        return false;
      } else {
        return true;
      }
    },
    isEmpty(obj) {
      for(var key in obj) {
        if(obj.hasOwnProperty(key))
          return false;
      }
      return true;
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    uppercase: function (value) {
      if (!value) return ''
      return value.toUpperCase()
    },
  },
  created() {
    if(this.$ls.get("userData") == null) {
      var user = this.$store.state.user;
      user.partnerID = this.$store.state.partner;
      user.langCode = this.$store.state.lang;
      user.name = this.$store.state.user.name;
      user.phone = this.$store.state.user.phone;
      user.joined = this.$store.state.user.joined;
      user.rank = this.$store.state.user.rank;
      user.gameID = this.$store.state.game;
      user.bg_theme = this.$store.state.bg_theme;
      this.$ls.set("userData", JSON.stringify(user));
    } else {
      this.updateStoreUserData();
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/globals.js